import { Action } from 'redux'

import { CLEAR_CARS } from '../constants'

export function clearCarsAction(): Action {
  return {
    type: CLEAR_CARS,
  }
}
